import { isAutomationUserAgent, isBotUserAgent, isBrowser, isValidUrl } from '@sortlist-frontend/utils';

import { getConfiguredFeaturesWithExperiments } from './utils';

export function shouldEvaluateClientSideExperiments(url: string) {
  if (!isBrowser() || !isValidUrl(url)) return false;

  const { configuredExperiments } = getConfiguredFeaturesWithExperiments(url);

  const hasConfiguredExperiments = configuredExperiments.length > 0;
  const isUserBot = isBotUserAgent(window.navigator.userAgent);
  const isUserAutomation = isAutomationUserAgent(window.navigator.userAgent);

  return hasConfiguredExperiments && !isUserBot && !isUserAutomation;
}
